import { Button } from "@material-ui/core"
import { withStyles } from "@material-ui/styles"


export const MenuButton = withStyles(() => ({
  root: {
    textTransform: "none",
    width: "100%",
    paddingLeft: 0
  },
}))(Button)


export default MenuButton
